import { toast } from "sonner";

interface ZodIssue {
	path: (string | number)[];
	message: string;
}

interface ZodServerError {
	message?: string;
	data?: {
		issues?: ZodIssue[];
	};
}

export function useZodServerError() {
	const setZodServerError = (error: unknown) => {
		const err = error as ZodServerError;

		if (err?.data?.issues && Array.isArray(err.data.issues)) {
			err.data.issues.forEach((issue) => {
				toast.error(issue.message, { id: issue.message });
			});
		}
	};

	return { setZodServerError };
}
